import { useLocation } from 'react-router-dom';
import ShopifyRequiredModalView from './ShopifyRequiredModal.View';
import { useShopify } from 'hooks';
import { ShopifyAppRedirect } from 'types/components/shopify';

const ShopifyRequiredModal = (props: { open: boolean; onClose: () => void }) => {
  const { pathname } = useLocation();
  const { setShopifyURLRedirect } = useShopify();

  const onContinue = () => {
    setShopifyURLRedirect({ path: pathname, key: ShopifyAppRedirect.Billing });
    window.open(
      import.meta.env.VITE_SHOPIFY_APP_LISTING_URL || 'https://apps.shopify.com/',
      '_self'
    );
  };

  return <ShopifyRequiredModalView {...props} onContinue={onContinue} />;
};

export default ShopifyRequiredModal;
